import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBreadcrumbs,{attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c(VBreadcrumbsItem,{attrs:{"to":item.to,"active-class":""}},[_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(item.text))])])]}},{key:"divider",fn:function(){return [_c(VIcon,{staticStyle:{"opacity":"0.5"},attrs:{"x-small":""}},[_vm._v("chevron_right")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }